import React from 'react';
import PropTypes from 'prop-types';

import {
  Form,
  Button
} from 'semantic-ui-react';

const APITokenForm = ({
  values,
  dirty,
  onSubmit,
  onChange,
  onCancel
}) => (
  <Form size='tiny' onSubmit={onSubmit}>
    <Form.Group>
      <Form.Input
        width={ 16 }
        label='Name'
        name='name'
        placeholder='Token Name'
        value={ values.name }
        onChange={ onChange }
      />
    </Form.Group>
    <Button.Group>
      <Button disabled={ !dirty } onClick={ onCancel } >Cancel</Button>
      <Button.Or />
      <Button positive={ dirty } disabled={ !dirty } type="submit">Save</Button>
    </Button.Group>
  </Form>
)

APITokenForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  dirty: PropTypes.bool.isRequired
}

export default APITokenForm



// WEBPACK FOOTER //
// ./webAdmin/forms/apiToken.js